module.exports = __webpack_public_path__ + "media/images/user/logo_portal__green-ec23834f42a5e29e307f67aa50fb0860.svg";